import React from "react";
import { useTranslation } from "react-i18next";

export default function LoadingSpinner(): React.ReactElement {
	const { t } = useTranslation();

	return (
		<div className="Loading_mainContainer">
			<div className="Loading_spinnerContainer">
				<div className="Loading_spinner"></div>
			</div>
			<div className="Loading_text">{t("screenshotHistory.loadingScreenshot")}</div>
		</div>
	);
}
